import { cn } from 'lib/helpers/utility';

import Icon from 'components/shared/Icon/Icon';
import Button from 'components/shared/Button/Button';

const SubModal = ({
  subModalContent,
  subModalVisible,
  subModalTitle,
  subModalClassName,
  subModalPanelClassName,
  subModalActions,
  subModalFooter,
  subModalHeaderActions,
  onClose
}) => {
  if (!subModalContent && !subModalVisible) return null;

  const renderFooterContent = () => {
    if (subModalFooter === false) return null;

    if (subModalFooter) {
      return typeof subModalFooter === 'function' ? subModalFooter({ onClose }) : subModalFooter;
    }

    return (
      <>
        <Button text="Cancel" size="small" style="outlined" color="neutral" onClick={onClose} />
        {subModalActions?.onClick && (
          <Button
            text={subModalActions.text || 'Continue'}
            size="small"
            onClick={subModalActions.onClick}
            isLoading={subModalActions.isLoading}
            isDisabled={subModalActions.isDisabled}
          />
        )}
      </>
    );
  };

  const footerContent = renderFooterContent();

  return (
    <div
      className={cn(
        'absolute inset-0 z-[9999] flex h-full w-full flex-col justify-end transition-all duration-300',
        subModalVisible ? 'bg-black/20' : 'pointer-events-none bg-black/0'
      )}>
      <div className="flex-1 cursor-pointer" onClick={onClose} />
      <div
        className={cn(
          'flex max-h-[80%] min-h-[100px] w-full flex-col rounded-t-lg bg-white transition-transform duration-300',
          subModalVisible ? 'translate-y-0' : 'translate-y-full',
          subModalPanelClassName
        )}>
        <div className="flex shrink-0 items-center justify-between border-0 border-b border-solid border-neutral-100 px-4 py-2">
          <p className="py-1 text-sm font-medium text-neutral-800">{subModalTitle}</p>
          <div className="flex items-center gap-1">
            {subModalHeaderActions}
            <Icon icon="close-linear" className="cursor-pointer" onClick={onClose} />
          </div>
        </div>
        <div
          className={cn('flex flex-1 flex-col overflow-y-auto bg-neutral-50', subModalClassName)}>
          {subModalContent}
        </div>
        {footerContent !== null && (
          <div className="flex h-[56px] w-full shrink-0 items-center justify-end gap-2 border-0 border-t border-solid border-neutral-100 bg-white px-4 py-3">
            {footerContent}
          </div>
        )}
      </div>
    </div>
  );
};

export default SubModal;
